import { UserInteractionServiceV1 } from '@volkswagen-onehub/user-interaction-service';

export function checkOldCar(dateTimeStamp: number | null, years: number) {
	if (!dateTimeStamp) return false;

	const actualDate = new Date();
	actualDate.setFullYear(actualDate.getFullYear() - years);

	return new Date(dateTimeStamp) > actualDate;
}

export function actionRedirect(userInteractionService: UserInteractionServiceV1, action: string) {
	const [actionPath, paramString] = action.split('?');
	const handlerName = actionPath.replace('action:', '');
	const handler = userInteractionService.get(handlerName);

	let params: Record<string, string | string[]> = {};
	let paramsActionActivate = '';

	// Reset si no viene dealer en paramString → poner uno “neutral”
	if (!paramString || !paramString.includes('dealer=')) {
		params.dealer = 'none';
		paramsActionActivate = 'dealer=none';
	}

	if (paramString) {
		paramsActionActivate = paramString;
		const paramPairs = paramString.split('&');

		paramPairs.forEach((pair) => {
			const [key, value] = pair.split('=');
			params[key] = value;
		});
	}

	// @ts-ignore
	handler.onActivate(params, paramsActionActivate);
}

export function checkDateWithinDays(date: string | number, days: number): boolean {
	if (!date) return true;

	const targetDate = typeof date === 'string' ? new Date(date) : new Date(date);
	if (isNaN(targetDate.getTime())) return true;

	const currentDate = new Date();
	const diffInMilisenconds = currentDate.getTime() - targetDate.getTime();
	const diffInDays = Math.floor(diffInMilisenconds / (1000 * 60 * 60 * 24));

	return diffInDays <= days;
}

export function normalizeToTimestamp(dateInput: number | string | Date): number {
	if (typeof dateInput === 'string') {
		return new Date(dateInput).getTime();
	} else if (typeof dateInput === 'number') {
		return dateInput > 1000000000000 ? dateInput : dateInput * 1000;
	} else {
		return dateInput.getTime();
	}
}

export const strTitlelize = (str: string) => {
	if (!str) return '';
	return str
		.toLowerCase()
		.split(' ') // separar palabras para capitalizar
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
		.join(' ')
		.split('.') // separar sociedades para capitalizar (S.A., S.L.U.)
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
		.join('.');
};
